'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _users = require('./users.component');

var _users2 = _interopRequireDefault(_users);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersModule = _angular2.default.module('app.containers.users', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('users', {
    url: '/users',
    template: '<users></users>'
  });
  // .state('users', {
  //   url: '/users',
  //   template: '<users></users>'
  // })
}).component('users', _users2.default);

exports.default = usersModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/users/users.js
 **/